export const status = Object.freeze({
  APPROVED: 'approved',
  PENDING: 'pending',
  EXPIRED: 'expired',
  DISABLED: 'disabled',
  DELETION: 'deletion',
  UNCONFIRMED: 'unconfirmed',
} as const);
